module.exports = __webpack_public_path__ + "img/righsolid.8884a77e.svg";